"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridResponsiveExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/grid/examples/responsive.ts';
var breakpoints = Object.keys(_1.Breakpoints);
var GridResponsiveExample = /** @class */ (function () {
    function GridResponsiveExample() {
    }
    GridResponsiveExample.prototype.view = function () {
        return [
            (0, mithril_1.default)(examples_1.Example, { class: 'cui-example-grid', center: false, src: EXAMPLE_SRC }, [
                (0, mithril_1.default)(_1.Grid, { gutter: { xs: 0, sm: 10, md: 20, lg: 30, xl: 40 } }, [
                    (0, mithril_1.default)(_1.Col, { span: { xs: 12, md: 4 } }, (0, mithril_1.default)('.cui-example-grid-col', 'col')),
                    (0, mithril_1.default)(_1.Col, { span: { xs: 12, md: 4 } }, (0, mithril_1.default)('.cui-example-grid-col', 'col')),
                    (0, mithril_1.default)(_1.Col, { span: { xs: 12, md: 4 } }, (0, mithril_1.default)('.cui-example-grid-col', 'col'))
                ])
            ]),
            (0, mithril_1.default)(_1.Table, [
                (0, mithril_1.default)('tr', [
                    (0, mithril_1.default)('th', 'Size'),
                    (0, mithril_1.default)('th', 'Description')
                ]),
                breakpoints.map(function (breakpoint) { return (0, mithril_1.default)('tr', [
                    (0, mithril_1.default)('td', (0, mithril_1.default)('code', breakpoint)),
                    (0, mithril_1.default)('td', _1.Breakpoints[breakpoint])
                ]); })
            ])
        ];
    };
    return GridResponsiveExample;
}());
exports.GridResponsiveExample = GridResponsiveExample;
